<script lang="ts">
    import { createEventDispatcher } from 'svelte';
    import { Howler } from 'howler';
    import clickSound from '@src/utils/useClickSound.js';

    //icons
    import IconLevelVolume from '../../../icons/icon-level-volume.svelte';
    // components
    import CardSimple from '../../card/card-simple.svelte';
    import RangeSlider from '../../range-slider/range-slider.svelte';
    import { updateUserSettings } from '@src/store/ui';
    import { clickOutside } from '@src/utils/ui';
    import { trackEvent } from '@root/src/utils/init-analytics.js';
    import IconMenu from '@root/src/components/icons/icon-menu.svelte';
    import { totalBet } from '@root/src/store/chips';

    //exports
    export let currency: string;
    export let isMuted = false;
    export let chipPrice: string;
    export let decimalValue = 2;

    let showSlider = false;
    let volumeLevel = Howler.volume();
    const dispatch = createEventDispatcher();

    const updateVolume = value => (volumeLevel = Number(value));
    const handleChangeVolume = event => {
        updateVolume(event?.target.value);
        updateUserSettings({ musicEnabled: true, soundEnabled: true });

        trackEvent('sound_change', {
            volume_new_state: event.target.value,
            music_new_state: Number(event.target.value) > 0 ? 'on' : 'off',
            sound_new_state: Number(event.target.value) > 0 ? 'on' : 'off',
            change_origin: 'main_screen'
        });
    };

    const handleVolumeIcon = () => {
        showSlider = true;
        updateVolume(!volumeLevel);
        updateUserSettings({ musicEnabled: isMuted, soundEnabled: isMuted });

        trackEvent('sound_change', {
            music_new_state: isMuted ? 'on' : 'off',
            sound_new_state: isMuted ? 'on' : 'off',
            change_origin: 'main_screen'
        });
    };

    $: volumeLevel = isMuted ? 0 : 0.7;
    $: Howler.volume(volumeLevel);
</script>

<div class="absolute -left-2 top-2.5 p-1 s-phone:p-2 desktop:!fixed desktop:left-6 desktop:top-auto">
    <div class="inline-flex gap-x-2">
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div
            class="button-controls-main-wrapper hidden justify-start !bg-none desktop:block"
            on:click={() => dispatch('menu')}
            use:clickSound={{ sound: 'audio_modal_open' }}
        >
            <IconMenu />
        </div>

        <div class="button-controls-main-wrapper hidden !bg-none desktop:block">
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="relative z-50"
                use:clickOutside={false}
                on:click_outside={() => (showSlider = false)}
                on:mouseenter={() => (showSlider = true)}
            >
                <IconLevelVolume {volumeLevel} muted={isMuted || volumeLevel === 0} on:click={handleVolumeIcon} />

                <div
                    id="range-slider-desktop"
                    class="absolute inset-0 -translate-y-12 translate-x-1 rotate-[270deg] transition-opacity duration-200"
                    class:opacity-0={!showSlider}
                >
                    <RangeSlider bind:value={volumeLevel} on:input={handleChangeVolume} />
                </div>
            </div>
        </div>
    </div>
</div>

<CardSimple title="Total Bet">
    <div class="max-w-xs truncate px-4 py-3.5">
        {currency}
        {$totalBet}
    </div>
</CardSimple>
